import es from 'url:../../../resource/images/es.png';
import en from 'url:../../../resource/images/en.png';
import fr from 'url:../../../resource/images/fr.png';
const previewLanguage = (lg) => {
    switch (lg) {
        case 'en-US':
            return [en, 'DONATE', 'Other amount ...', 'English'];
        case 'es-ES':
            return [es, 'DONAR', 'Otro monto ...', 'Español'];
        default:
            return [fr, 'DONNER', 'Autre montant ...', 'Français'];
    }
};
export default previewLanguage;